/** Fired by a filter popover when it opens, so other open popovers on the page can close themselves. */
export const POPOVER_OPEN_EVENT = 'studio:popover-open'
